import { HttpInterceptorFn } from '@angular/common/http';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const locale = localStorage.getItem('lang') || 'pt-BR';

  const backendLang = mapToBackendLocale(locale);

  const cloned = req.clone({
    setHeaders: {
      'Accept-Language': backendLang,
    },
  });

  return next(cloned);
};

function mapToBackendLocale(locale: string): string {
  if (locale.startsWith('pt')) return 'pt';
  if (locale.startsWith('es')) return 'es';
  return 'en'; 
}